import { produce } from 'immer';
import { identity, omit } from 'ramda';

import * as TypesCore from '@core/js/hooks/user/store/types';
import { loadGuestIdFromStorage } from '@core/js/hooks/user/helpers';
import { actionTypes as actionTypesCore } from '@core/js/hooks/user/store/constants';
import { defaultState as coreDefaultState, reducer as coreReducer } from '@core/js/hooks/user/store/reducer';

import * as Types from './buzz/types';
import { actionTypes } from './buzz/constants';

export const defaultState: Types.IUserState = {
    ...(coreDefaultState as Types.IUserState),
    ...loadGuestIdFromStorage(),
    justRegistered: false,
    urlTemplates: [],
    terms: {},
    updatedBalances: [],
    allPlayerTags: null,
    paymentsStatistics: {},
    jumioState: '',
    jumioStep: 'start',
    actionAfterLogin: identity,
    futureAnthemsList: {},
    isOccupationSet: false,
    isShowOccupationPopup: false
};

export const reducer = produce((draftState, action: Types.TUserAction): Types.IUserState | void => {
    switch (action.type) {
        case actionTypesCore.RESET_TO_DEFAULT: {
            // have to preserve these properties
            // even when reset is happening
            const {
                lang,
                hideBalance,
                hasBeenLoggedIn,
                suspended,
                clientIp,
                daydepositlimit,
                weekdepositlimit,
                monthdepositlimit,
                currencyCode,
                country,
                countrySetByGeoIp,
                geoData,
                promoCode,
                registrationInfo,
                userAvailabilityVerificationToken,
                signUpVerificationToken,
                relogin,
                reloginCredentials,
                terms
            } = draftState;

            return {
                ...defaultState,
                lang,
                hideBalance,
                hasBeenLoggedIn,
                suspended,
                clientIp,
                daydepositlimit,
                weekdepositlimit,
                monthdepositlimit,
                currencyCode,
                country,
                countrySetByGeoIp,
                geoData,
                promoCode,
                registrationInfo,
                userAvailabilityVerificationToken,
                signUpVerificationToken,
                relogin,
                reloginCredentials,
                terms
            };
        }

        case actionTypes.SET_URL_TEMPLATES: {
            draftState.urlTemplates = action.payload;

            break;
        }
        case actionTypes.SET_TERMS: {
            draftState.terms = action.payload;

            break;
        }

        case actionTypes.SET_ALL_PLAYER_TAGS: {
            draftState.allPlayerTags = action.payload;

            break;
        }

        case actionTypes.REMOVE_PLAYER_TAG: {
            draftState.allPlayerTags = omit([action.payload], draftState.allPlayerTags);

            break;
        }

        case actionTypes.SET_JUST_REGISTERED: {
            draftState.justRegistered = action.payload;

            break;
        }
        case actionTypes.SET_UPDATED_BALANCES: {
            draftState.updatedBalances = action.payload;

            break;
        }
        case actionTypes.SET_JUMIO_STATUS: {
            draftState.jumioState = action.payload;

            break;
        }
        case actionTypes.SET_JUMIO_STEP: {
            draftState.jumioStep = action.payload;

            break;
        }
        case actionTypes.SET_ACTION_AFTER_LOGIN: {
            draftState.actionAfterLogin = action.payload;

            break;
        }
        case actionTypes.SET_FUTURE_ANTHEMS_GAMES: {
            const { recommendationType, ...futureAnthemsObj } = action.payload;

            draftState.futureAnthemsList = {
                ...draftState.futureAnthemsList,
                [recommendationType]: Object.assign(
                    {}, draftState.futureAnthemsList[recommendationType], futureAnthemsObj
                )
            };

            break;
        }
        case actionTypes.SET_OCCUPATION: {
            draftState.isOccupationSet = action.payload;

            break;
        }
        case actionTypes.SET_IS_SHOW_OCCUPATION_POPUP: {
            draftState.isShowOccupationPopup = action.payload;

            break;
        }
        default: {
            return coreReducer(draftState as TypesCore.IUserState, action) as Types.IUserState;
        }
    }
}, defaultState);
